import * as React from "react"

const WarningIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.46997 19H19.53L12 5.98999L4.46997 19ZM13 18H11V16H13V18ZM13 14H11V9.99999H13V14Z"
      fill="url(#paint0_linear_619_756)"
    />
    <path d="M1 21H23L12 2L1 21ZM4.47 19L12 5.99L19.53 19H4.47ZM11 16H13V18H11V16ZM11 10H13V14H11V10Z" fill="#616161" />
    <defs>
      <linearGradient
        id="paint0_linear_619_756"
        x1="4.46997"
        y1="15.4518"
        x2="19.5339"
        y2="14.3133"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EABB90" />
        <stop offset="1" stopColor="#F3EB73" />
      </linearGradient>
    </defs>
  </svg>
)

export default WarningIcon
